import Section from './_Section'
import { transformPaddingToTailwind } from '../../helpers/style'

const DEFAULT_HEIGHT = '800'

function IframeEmbed(props) {
  if (!props.url) {
    return null
  }

  const componentPadding = transformPaddingToTailwind(props.componentPadding)
  const iframeId = `iframe-embed-${props.idx}`

  return (
    <Section type="iframeEmbed" outerClass={componentPadding} sectionTitle={false} innerClass="px-6" {...props}>
      <iframe
        id={iframeId}
        src={props.url}
        title={props.iframeTitle}
        className="w-full border-0"
        height={props.height || DEFAULT_HEIGHT}
        loading="lazy"
      />
    </Section>
  )
}

export default IframeEmbed
